import Rendering1 from "@/assets/images/3D/3d.png";
import LightingCoverageImg from "@/assets/images/lighting/lighting_cover.png";
import WifiCardImg from "@/assets/images/wifi/wifi.png";
import Lighting1 from "@/assets/images/lighting/Lighting.png";
import ArchFloorPlan from "@/assets/images/services/arch_floor_plan.png";
import ArchSitePlan from "@/assets/images/services/arch_site_plan.png";
import StructuralElevationsSectionPlans from "@/assets/images/services/sturct_elevation.png";
import RcpPlans from "@/assets/images/services/rcp_plan.png";
import LineDiagram2 from "@/assets/images/linediagram/2.png";
import programming_draw from "@/assets/images/services/programming_draw.png";

export const draftingServices = [
  {
    id: 1,
    title: 'Architectural Site Plans',
    description: 'Comprehensive site plans showing building footprints, property boundaries, setbacks, parking layouts, and site access for residential and commercial developments with accurate surveying data.',
    image: ArchSitePlan,
    icon: 'ri-map-pin-line',
    tags: ['Site Layout', 'Property Lines', 'Parking Design']
  },
  {
    id: 2,
    title: 'Architectural Floor Plans',
    description: 'Detailed floor plans with room layouts, dimensions, door and window schedules, and spatial arrangements for residential and commercial buildings ensuring optimal functionality and flow.',
    image: ArchFloorPlan,
    icon: 'ri-layout-grid-line',
    tags: ['Floor Layouts', 'Room Planning', 'Dimensions']
  },
  {
    id: 3,
    title: 'Structural Elevations/Section Plans',
    description: 'Vertical section cuts and elevation views showing building heights, floor levels, roof structures, and wall assemblies with detailed construction specifications and material callouts.',
    image: StructuralElevationsSectionPlans,
    icon: 'ri-building-2-line',
    tags: ['Elevations', 'Sections', 'Building Heights']
  },
  {
    id: 4,
    title: 'RCP Plans',
    description: 'Reflected Ceiling Plans detailing ceiling layouts, lighting fixtures, HVAC diffusers, sprinkler heads, and ceiling heights for coordinated building systems installation.',
    image: RcpPlans,
    icon: 'ri-lightbulb-line',
    tags: ['Ceiling Design', 'Lighting Layout', 'HVAC']
  },
  {
    id: 5,
    title: '3D Photorealistic Renderings',
    description: 'High-quality photorealistic 3D visualizations of interior and exterior spaces with realistic materials, lighting, and textures for client presentations and marketing materials.',
    image: Rendering1,
    icon: 'ri-image-2-line',
    tags: ['3D Visualization', 'Rendering', 'Presentation'],
    disclaimer: { label: 'For Reference', description: 'Renderings are for illustrative purposes only. Final output may differ based on project specifications and client requirements.' }
  },
  {
    id: 6,
    title: 'Line Diagrams',
    description: 'Single-line electrical diagrams, plumbing schematics, and system flow diagrams showing connections, circuits, and equipment layouts for building systems coordination.',
    image: LineDiagram2,
    icon: 'ri-flow-chart',
    tags: ['Electrical', 'Schematics', 'Systems']
  },
  {
    id: 7,
    title: 'Lighting Design & Analysis',
    description: 'Comprehensive lighting plans with fixture schedules, photometric calculations, and illumination analysis ensuring proper lighting levels and energy efficiency compliance.',
    image: Lighting1,
    icon: 'ri-flashlight-line',
    tags: ['Lighting Plans', 'Photometrics', 'Energy Analysis'],
    disclaimer: { label: 'Sample Work', description: 'Lighting analysis values shown are samples. Actual results depend on site conditions, fixture selection, and project scope.' }
  },
  {
    id: 8,
    title: 'Wifi Coverage',
    description: 'Wireless network coverage plans showing access point locations, signal strength mapping, and network infrastructure layouts for optimal connectivity throughout buildings.',
    image: WifiCardImg,
    icon: 'ri-wifi-line',
    tags: ['Network Design', 'Coverage Maps', 'Access Points'],
    disclaimer: { label: 'Indicative', description: 'Wi-Fi coverage shown is indicative. Actual performance depends on hardware, building materials, and environmental factors.' }
  },
  {
    id: 9,
    title: 'Lighting Coverage',
    description: 'Detailed lighting coverage analysis with illumination heat maps, lux level distributions, and fixture placement optimization for uniform lighting throughout spaces.',
    image: LightingCoverageImg,
    icon: 'ri-sun-line',
    tags: ['Illumination Maps', 'Lux Levels', 'Coverage Analysis'],
    disclaimer: { label: 'Sample Work', description: 'Lighting coverage data is illustrative. Actual lux levels depend on installed fixtures, room geometry, and surface finishes.' }
  },
  {
    id: 10,
    title: 'Programming Schedule Drawings',
    description: 'Project programming and phasing diagrams showing construction schedules, space allocation plans, and room data sheets for facility planning and project management.',
    image: programming_draw,
    icon: 'ri-calendar-schedule-line',
    tags: ['Project Phasing', 'Space Programming', 'Schedules']
  }
];
